import { pridelavaService } from '../services/pridelava.service';
import Vue from 'vue';


const state = {
    pridelava: null,
    pridelovalec:{kontakt:[{}]},
    sezona:null,
   storedfilter: {
                logic: "and",
                filters: [
                    { field: "jeaktivna", operator: "neq", value: 0}
                ]
            },
};

const actions = {
     clear({ dispatch,commit }) {
       
       dispatch('alert/clear', "",{ root: true });
       let pridelovalec={kontakt:[{}]};
       commit('loadOne', pridelovalec)
     },
    load({ dispatch, commit },{sezona}) {
     
        dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)
         return pridelavaService.load(sezona)
            .then(
                pridelava =>  {
                 
                    commit('load', pridelava);
                    return pridelava;
                },
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                }
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
    loadShema({ dispatch, commit },{sezona,shema}) {
     
        dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)

         return pridelavaService.loadShema(sezona,shema)
            .then(
                pridelava =>  {
                 
                    commit('load', pridelava);
                    return pridelava;
                },
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                }
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
    
    loadIdPoSezoni({ dispatch,commit },{sezona,pridelovalecid}) {
   
          dispatch('alert/clear', "",{ root: true });
       return new Promise((resolve, reject) => {

        pridelavaService.loadIdPoSezoni(sezona,pridelovalecid)
            .then(
                pridelovalec => {
                  if(pridelovalec==""){
                    var error="Pridelovalec v tej sezoni ne obstaja!";
                      console.log(error);
                    dispatch('alert/error', error, { root: true });
                    reject(error);
                  }
                    else {
                  
                commit('loadOne', pridelovalec)
                resolve(pridelovalec)
                }
              },
                error => {
                    console.log("Pridelovalec v tej sezoni ne obstaja!");
                    dispatch('alert/error', error, { root: true });
                    reject(error);
            }
            )

          });
    },

    loadOne({ dispatch,commit },{sezona,pridelovalecid}) {
   
          dispatch('alert/clear', "",{ root: true });
            return new Promise((resolve, reject) => {

        pridelavaService.loadOne(pridelovalecid,sezona)
            .then(
                pridelovalec => {

                  commit('loadOne', pridelovalec)
                  resolve(pridelovalec);

              },
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                    reject(error)
            }
            );
          });
            
    },
     loadbykmgmid({ dispatch,commit },{kmgmid}) {
        
          dispatch('alert/clear', "",{ root: true });
       return pridelavaService.loadbykmgmid(kmgmid)
            .then(
                pridelovalec => {
                    
                    if(!pridelovalec){
                    dispatch('alert/error', "Pridelovalec s to številko ni bil najden!", { root: true });    
                     pridelovalec={};
                }
                commit('loadOne', pridelovalec)
                }

                //,
                //error => commit('getLoggedInFailure', error)
            ),
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                   
            };
    },
   loadbyds({ dispatch,commit },{ds}) {
        
          dispatch('alert/clear', "",{ root: true });
        return pridelavaService.loadbyds(ds)
            .then(
                pridelovalec => {
                    
                    if(!pridelovalec){
                    dispatch('alert/error', "Pridelovalec s to številko ni bil najden!", { root: true });
                     pridelovalec={};
            }
                    else if (!pridelovalec.kmgmid)    
                         dispatch('alert/warning', "Ta pridelovalec ni nosilec kmetijskega gospodarstva!", { root: true });
                 commit('loadOne', pridelovalec)
             }

                //,
                //error => commit('getLoggedInFailure', error)
            ),
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                   
            };
    },
    loadbyemso({ dispatch,commit },{emso}) {
        //commit('load');
          dispatch('alert/clear', "",{ root: true });
        return pridelavaService.loadbyemso(emso)
            .then(
                pridelovalec => {
                   
                    if(!pridelovalec){
                    dispatch('alert/error', "Pridelovalec s to številko ni bil najden!", { root: true });
                    pridelovalec={}
                    }
                    else if (!pridelovalec.kmgmid)    
                         dispatch('alert/warning', "Ta pridelovalec ni nosilec kmetijskega gospodarstva!", { root: true });


                    commit('loadOne', pridelovalec)
                }
                //,
                //error => commit('getLoggedInFailure', error)
            ),
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                   
            };
    },
     savekmg({ dispatch,commit },{kontrolnastevilka,sezona}) {
        

        commit('updatekontrolnastevilka', kontrolnastevilka)
        commit('updatesezona', sezona)
        let pridelovalec=this.state.pridelava.pridelovalec;
       dispatch('alert/clear', "",{ root: true });

          return new Promise((resolve, reject) => {
            //if(!kontrolnastevilka) {
              //  var error="Kontrolna številka je prazna!"
            //console.log(error);
            //dispatch('alert/error', error, { root: true });
            //reject(error)
            //}
            //else{

                  
                pridelavaService.add(pridelovalec)
            .then(
                pridelovalec => {
                    
                    if(!pridelovalec){
                    dispatch('alert/error', "Pridelovalec s to številko ni bil najden!", { root: true });    
                     pridelovalec={};
                }
                commit('loadOne', pridelovalec)
                 dispatch('alert/success', "Pridelovalec je bil uspešno shranjen!", { root: true });   
                resolve(pridelovalec);
                },
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                    reject(error)
                   
            });


           //}


          });


    },
     save({ dispatch,commit },{sezona}) {
        

        
        commit('updatesezona', sezona)
        let pridelovalec=this.state.pridelava.pridelovalec;
       dispatch('alert/clear', "",{ root: true });

          return new Promise((resolve, reject) => {
                pridelavaService.save(pridelovalec)
            .then(
                pridelovalec => {
                    
                  
                 dispatch('alert/success', "Podatki o pridelovalcu so bili uspešno shranjeni!", { root: true });   
                resolve(pridelovalec);
                },
                error => {
                    console.log("Shranjevanje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                    reject(error)
                   
            });


        


          });


    },
    select({ commit },{pridelovalec}) {
        commit('loadOne',pridelovalec);

    },
    replace({ commit },{pridelava}) {
        commit('replace',pridelava);

    }
};

const mutations = {
     setSezona(state, item) {
        state.sezona=item;
    },
    load(state, pridelava) {
      state.pridelava=pridelava.map(k=>{
            k["datumdolocitvestatusa"]=kendo.parseDate(k["datumdolocitvestatusa"]) 
            return k;
        });
       // state.pridelava = pridelava;
    },
    replace(state, pridelava) {
        state.pridelava = pridelava;
    },
    loadOne(state, pridelovalec) {
         //state.pridelovalec = Object.assign({}, this.someObject,pridelovalec)
         state.pridelovalec=pridelovalec;
         
         
    },
    updatefilter(state, filter) {
          state.storedfilter=filter;
         
    },
    updateemso(state, emso) {
         Vue.set( state.pridelovalec, 'emso',emso);
         
    },
    updateds(state, ds) {
         Vue.set( state.pridelovalec, 'ds',ds);
         
    },
    
    updatekmgmid(state, kmgmid) {
         Vue.set( state.pridelovalec, 'kmgmid',kmgmid);
         
    },
     updatekontrolnastevilka(state, kontrolnastevilka) {
         Vue.set( state.pridelovalec, 'kontrolnastevilka',kontrolnastevilka);
         
    },
    
     updatesezona(state, sezona) {
         Vue.set( state.pridelovalec, 'sezona',sezona);
         
    },
      updatestatusid(state, statusid) {
         Vue.set( state.pridelovalec, 'statusid',statusid);
         
    },
    
      updatedatumdolocitvestatusa(state, datumdolocitvestatusa) {
         Vue.set( state.pridelovalec, 'datumdolocitvestatusa',datumdolocitvestatusa);
         
    },
      updateprop(state, {property,value}) {
         Vue.set( state.pridelovalec, property,value);
         
    },
      updateshemaprop(state, {shema,sezona,property,value}) {

         Vue.set( state.pridelovalec.sheme.find(s=>s.sezona==sezona&&s.shema==shema), property,value);
         
    },
     updatekontaktprop(state, {property,value}) {

         Vue.set( state.pridelovalec.kontakt[0], property,value);
         
    },
    
    loadOne(state, pridelovalec) {
         //state.pridelovalec = Object.assign({}, this.someObject,pridelovalec)
         state.pridelovalec=pridelovalec;
         
         
    },
    loadOneRKG(state, pridelovalec) {
        //state.pridelovalec = Object.assign({}, this.someObject,pridelovalec)
        state.pridelovalec=pridelovalec;
        
        
   },
   
    
    save(state, pridelovalec) {
        
        state.pridelovalec = pridelovalec;
    },
   
};

export const pridelava = {
    namespaced: true,
    state,
    actions,
    mutations
};
